import { ChipSizeVariant } from './types';
import styles from './Chip.module.scss';

export const getChipWrapperClass = (size: ChipSizeVariant) => {
    return styles[`chip--${size}`];
};
